import { FadeUp, SectionTag } from "./Reveal";

const CHAPTERS = [
    {
        n: "01",
        title: "More than something you play",
        body: "We believe online games should be more than something you log into. They should be places — where people meet, build identities, form communities, and make memories that outlast any session.",
    },
    {
        n: "02",
        title: "Identity is the progression",
        body: "Who you are matters more than what you defeat. Style, reputation, friendships, the space you call home — these are the things worth leveling up.",
    },
    {
        n: "03",
        title: "Places, not lobbies",
        body: "A world should persist whether you are watching or not. Streets you recognize, corners that carry your history, neighborhoods shaped by the people who live in them.",
    },
];

export const Vision = () => (
    <section id="vision" className="relative py-24 sm:py-32">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionTag index="01" label="Our Vision" />

            <FadeUp>
                <h2
                    data-testid="vision-heading"
                    className="font-serif-accent italic text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.08] max-w-3xl"
                >
                    Games end.
                    <br />
                    <span className="text-[#A855F7]">Worlds remain.</span>
                </h2>
            </FadeUp>

            <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
                {CHAPTERS.map((c, i) => (
                    <FadeUp key={c.n} delay={i * 0.12} className="h-full">
                        <article
                            data-testid={`vision-chapter-${c.n}`}
                            className="group h-full bg-[#0A0A0F] p-8 sm:p-10 transition-colors duration-500 hover:bg-[#12121A]"
                        >
                            <span className="font-mono-meta text-xs tracking-[0.35em] text-[#A855F7]">
                                CH. {c.n}
                            </span>
                            <h3 className="mt-6 font-display font-bold text-xl sm:text-2xl text-white leading-snug group-hover:text-[#C084FC] transition-colors duration-500">
                                {c.title}
                            </h3>
                            <p className="mt-5 text-sm sm:text-base text-slate-400 leading-relaxed">
                                {c.body}
                            </p>
                            <span className="mt-8 block h-px w-10 bg-white/20 group-hover:w-full group-hover:bg-[#A855F7]/60 transition-all duration-700" />
                        </article>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);
